// extracted by mini-css-extract-plugin
export var dropdownContainer = "_sq-0";
export var leftAlign = "_sq-4";
export var listItem = "_sq-2";
export var listItemWrapper = "_sq-1";
export var operationText = "_sq-3";